module.exports = __webpack_public_path__ + "img/IATA北京2026_01.e023d04c.webp";